<template>
  <auth-shell>
    <auth-card
      ref="card"
      title="Восстановление доступа к аккаунту"
      :description="stepDescription"
      error-id="password-reset-error"
      :error-message="authError"
      :loading="submitting"
      :loading-message="showNextStep ? 'Меняем пароль' : 'Отправляем код'"
    >
      <q-form v-if="!showNextStep" class="auth-form" @submit.prevent="onRequestCode">
        <q-input
          v-model="email"
          outlined
          label="Email"
          type="email"
          name="email"
          autocomplete="email"
          :disable="submitting"
          :aria-describedby="authError ? 'password-reset-error' : undefined"
          :rules="emailRules"
        >
          <template #prepend><q-icon name="email" aria-hidden="true" /></template>
        </q-input>
        <q-btn
          unelevated
          no-caps
          color="primary"
          class="auth-submit"
          label="Получить код"
          type="submit"
          :loading="submitting"
          :disable="submitting"
        />
      </q-form>

      <q-form v-else class="auth-form" @submit.prevent="onSubmit">
        <q-input
          v-model="code"
          outlined
          label="Проверочный код"
          name="one-time-code"
          autocomplete="one-time-code"
          :disable="submitting"
          :aria-describedby="authError ? 'password-reset-error' : undefined"
          :rules="codeRules"
        >
          <template #prepend><q-icon name="shield" aria-hidden="true" /></template>
        </q-input>
        <password-input
          v-model="password"
          autocomplete="new-password"
          :disable="submitting"
          :describedby="authError ? 'password-reset-error' : ''"
          :rules="passwordRules"
        />
        <q-btn
          unelevated
          no-caps
          color="primary"
          class="auth-submit"
          label="Сменить пароль"
          type="submit"
          :loading="submitting"
          :disable="submitting"
        />
      </q-form>

      <template #footer>
        <p><router-link :to="{ name: 'signin' }">Вернуться ко входу</router-link></p>
      </template>
    </auth-card>
  </auth-shell>
</template>

<script>
import axios from 'axios'
import { AuthCard, AuthShell, PasswordInput } from '../../components/auth'
import { apiUrl } from '../../config'

export default {
  name: 'change_password',
  components: { AuthCard, AuthShell, PasswordInput },
  data() {
    return {
      email: '',
      password: '',
      code: '',
      authError: '',
      submitting: false,
      showNextStep: false,
      emailRules: [
        (value) => Boolean(value) || 'Введите email',
        (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || 'Неверный формат email'
      ],
      codeRules: [(value) => Boolean(value) || 'Введите код'],
      passwordRules: [
        (value) => Boolean(value) || 'Введите пароль',
        (value) => value.length >= 8 || 'Пароль должен быть не короче 8 символов'
      ]
    }
  },
  computed: {
    stepDescription() {
      return this.showNextStep
        ? `Введите код, отправленный на ${this.email}, и новый пароль.`
        : 'Укажите email аккаунта — мы отправим проверочный код.'
    }
  },
  methods: {
    showError(message) {
      this.authError = message
      this.$refs.card.focusError()
    },
    async onRequestCode() {
      if (this.submitting) return
      this.submitting = true
      this.authError = ''
      try {
        const response = await axios.post(`${apiUrl}/change/password/request/`, { email: this.email }, {})
        if (response.data.error !== undefined) {
          this.showError('Неверный email')
          return
        }
        this.showNextStep = true
        this.$q.notify({ color: 'positive', icon: 'check', message: 'Код восстановления отправлен на почту' })
      } catch {
        this.showError('Не удалось отправить код. Повторите попытку позже.')
      } finally {
        this.submitting = false
      }
    },
    async onSubmit() {
      if (this.submitting) return
      this.submitting = true
      this.authError = ''
      try {
        const response = await axios.post(`${apiUrl}/change/password/submit/`, {
          email: this.email,
          code: this.code,
          new_password: this.password
        }, {})
        if (response.data.error !== undefined) {
          this.showError('Неверный код')
          return
        }
        this.$q.notify({ color: 'positive', icon: 'check', message: 'Пароль успешно изменен' })
        await this.requestToken()
      } catch {
        this.showError('Не удалось сменить пароль. Повторите попытку позже.')
      } finally {
        this.submitting = false
      }
    },
    async requestToken() {
      const response = await axios.post(`${apiUrl}/user/token/request/`, {}, {
        auth: { username: this.email, password: this.password }
      })
      if (response.data.token === undefined) throw new Error('missing-token')
      this.connection.updateCredentials(this.$q, response.data.token, response.data.token_uuid, true)
      this.connection.makeConnection(this.$q)
      this.$router.push({ name: 'profile' })
      if (response.data.user_info) this.emitter.emit('receiveUserInfo', response.data.user_info)
    }
  }
}
</script>
